'use client';

import React, { useState } from 'react';
import { Stepper, Step, StepLabel, Box, Button, Fade, styled, StepConnector } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import LockIcon from '@mui/icons-material/Lock';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import SettingsIcon from '@mui/icons-material/Settings';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import BasicInfo from '../../components/Estimator/BasicInfo';
import Quantities from '../../components/Estimator/Quantities';
import RowCalculator from '../../components/Estimator/RowCalculator';
import PMInputs from '../../components/Estimator/PMInputs';
import Summary from '../../components/Estimator/Summary';
import EditPricing from './EditPricing';
import { EstimatorProvider } from '../../context/EstimatorContext';
const steps = ['Basic Info', 'Quantities', 'Row Calculator', 'PM Inputs', 'Summary'];

const CustomStepIcon = ({ active, completed, icon }) => {
  if (completed) return <CheckCircleIcon color="success" sx={{ fontSize: 30 }} />;
  if (active) return <LockIcon color="primary" sx={{ fontSize: 30 }} />;
  return <MoreHorizIcon color="disabled" sx={{ fontSize: 30 }} />;
};

const CustomConnector = styled(StepConnector)(({ theme }) => ({
  '& .MuiStepConnector-line': {
    borderTopWidth: 3,
    transition: 'all 0.3s ease-in-out',
    borderColor: theme.palette.grey[300],
  },
  '&.Mui-active .MuiStepConnector-line': {
    borderColor: theme.palette.success.main,
  },
  '&.Mui-completed .MuiStepConnector-line': {
    borderColor: theme.palette.success.main,
  },
}));

export default function NewEstimate() {
  const [activeStep, setActiveStep] = useState(0);
  const [completed, setCompleted] = useState({});
  const [showSettings, setShowSettings] = useState(false);

  const handleNext = () => {
    setCompleted((prev) => ({ ...prev, [activeStep]: true }));
    setActiveStep((prev) => prev + 1);
  };

  const handleBack = () => {
    setActiveStep((prev) => prev - 1);
  };

  const isStepComplete = (step) => !!completed[step];

  const renderStepContent = () => {
    switch (activeStep) {
      case 0:
        return <BasicInfo onComplete={handleNext} />;
      case 1:
        return <Quantities onComplete={handleNext} />;
      case 2:
        return <RowCalculator onComplete={handleNext} />;
      case 3:
        return <PMInputs onComplete={handleNext} />;
      case 4:
        return <Summary />;
      default:
        return null;
    }
  };

  return (
    <EstimatorProvider>
      <Box sx={{ width: '100%', p: 4 }}>
        {!showSettings && (
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
            <Button variant="contained" color="primary" onClick={() => setShowSettings(true)}>
              Create and Save Changes
            </Button>
          </Box>
        )}

        {showSettings ? (
          <>
            <Box sx={{ mb: 2, display: 'flex', justifyContent: 'flex-start' }}>
              <Button variant="contained" onClick={() => setShowSettings(false)}>
                Back
              </Button>
            </Box>
            <EditPricing />
          </>
        ) : (
          <>
            <Stepper activeStep={activeStep} alternativeLabel connector={<CustomConnector />}>
              {steps.map((label, index) => (
                <Step key={label} completed={isStepComplete(index)}>
                  <StepLabel
                    StepIconComponent={(props) => (
                      <CustomStepIcon active={props.active} completed={props.completed} icon={props.icon} />
                    )}
                  >
                    {label}
                  </StepLabel>
                </Step>
              ))}
            </Stepper>

            <Fade in timeout={500}>
              <Box sx={{ mt: 4 }}>{renderStepContent()}</Box>
            </Fade>

            <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-start' }}>
              {activeStep > 0 && (
                <Button onClick={handleBack} variant="outlined">
                  Back
                </Button>
              )}
            </Box>
          </>
        )}
      </Box>
    </EstimatorProvider>
  );
}
